<template>
  <!-- GLOBAL: Footer -->

  <footer class="Footer">

    <div class="etx-container Container bg-secondary pb-50">
      <div class="etx-center Center">

        <div class="etx-flex Flex gv-200">

          <!-- <div class="etx-flex__item Flex__item tab-l:c-3"> -->
          <div class="etx-flex__item Flex__item tab-m:c-3">

            <div class="FooterLogo">
              <a href="/">
                <img v-if="tenantId == 'equans'" class="neg" src="assets/symbols/logo_equans_neg.svg"
                  alt="Logo Equans Switzerland" />
                <img v-if="tenantId == 'kuma'" class="neg" src="assets/symbols/logo_kuma_neg.svg"
                  alt="Logo Kummler+Matter EVT AG" />
              </a>
            </div>

            <div class="etx-spacer h-25"></div>

            <div class="etx-text Text">
              <p><span class="font-color-primary font-weight-bold font-size-large">{{ companyName }}</span><br />
                <span v-html="addressText" />
              </p>
            </div>

            <div class="etx-spacer h-25"></div>

            <div class="FooterContacts">

              <div class="etx-item-list ItemList">

                <a class="etx-item Item" :href="`tel:${phoneNumber}`">
                  <div class="etx-item__icon Item__icon">
                    <i class="fal fa-phone"></i>
                  </div>
                  <div class="etx-item__text Item__text">
                    <strong>{{ phoneNumber }}</strong>
                  </div>
                </a>

                <a class="etx-item Item" :href="`mailto:${emailAddress}`">
                  <div class="etx-item__icon Item__icon">
                    <i class="fal fa-envelope"></i>
                  </div>
                  <div class="etx-item__text Item__text">
                    <strong>{{ emailAddress }}</strong>
                  </div>
                </a>

              </div>

            </div>

          </div>

          <!-- <div class="etx-flex__item Flex__item tab-l:c-9"> -->
          <div class="etx-flex__item Flex__item tab-m:c-9 tab-l:c-6 tab-l:ml-3">

            <div class="etx-flex Flex gv-125 tab-m:gv-0">

              <!-- <div class="etx-flex__item Flex__item mob-m:c-5 tab-m:c-3 mob-m:mr-1 tab-l:ml-1 tab-l:mr-0"> -->
              <div class="etx-flex__item Flex__item mob-m:c-5 mob-m:mr-1 tab-m:ml-1 tab-m:mr-0">

                <div class="FooterNavMain">

                  <ul>
                    <li>
                      <a v-if="firstColumnLink" :href="firstColumnLink.url?.path" :title="firstColumnLink.label">{{
                        firstColumnLink.label }}</a>

                      <ul v-if="firstColumnSubtree && firstColumnSubtree.length">
                        <li v-for="link in firstColumnSubtree" :key="link.link.label">
                          <a v-if="link.link.url" :href="link.link.url.path" :title="link.link.label">{{ link.link.label
                            }}</a>
                        </li>
                      </ul>
                    </li>
                  </ul>

                </div>

              </div>

              <!-- <div class="etx-flex__item Flex__item mob-m:c-5 tab-m:c-3 mob-m:mr-1 tab-l:ml-1 tab-l:mr-0">

                <div class="FooterNavMain services">

                  <ul>
                    <li>
                      <a v-if="secondColumnLink"
                        :href="secondColumnLink.url?.path"
                        :title="secondColumnLink.label"
                      >{{ secondColumnLink.label }}</a>

                      <ul v-if="secondColumnSubtree && secondColumnSubtree.length">
                        <li v-for="group in secondColumnSubtree" :key="group.link.label">
                          <span>{{ group.link.label }}</span>
                          <ul>
                            <li v-for="link in group.subtree" :key="link.link.label">
                              <a v-if="link.link.url" :href="link.link.url.path" :title="link.link.label">{{
                                link.link.label }}</a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>


                </div>

              </div> -->

              <!-- <div class="etx-flex__item Flex__item mob-m:c-5 tab-m:c-3 mob-m:mr-1 tab-l:ml-1 tab-l:mr-0"> -->
              <div class="etx-flex__item Flex__item mob-m:c-5 mob-m:mr-1 tab-m:ml-1 tab-m:mr-0">

                <div class="FooterNavMain">

                  <ul v-if="thirdColumnLinks && thirdColumnLinks.length">
                    <li v-for="link in thirdColumnLinks" :key="link.label">
                      <a v-if="link.url" :href="link.url.path" :title="link.label">{{ link.label }}</a>
                    </li>
                  </ul>

                </div>

              </div>

            </div>

          </div>

        </div>


        <div class="etx-spacer Spacer h-50"></div>


        <div class="etx-flex Flex gv-150 mob-l:gv-0 a-space-between av-bottom">

          <div class="etx-flex__item Flex__item mob-l:c-auto tab-s:c-6 tab-l:c-3">

            <div v-if="linkedin || instagram || facebook || youtube" class="FooterSocial">
              <a v-if="linkedin" :href="linkedin?.uri?.path" :title="$texts('footer.linkedin', 'LinkedIn')"
                target="_blank">
                <i class="fab fa-linkedin-in"></i>
              </a>

              <a v-if="instagram" :href="instagram?.uri?.path" :title="$texts('footer.instagram', 'Instagram')"
                target="_blank">
                <i class="fab fa-instagram"></i>
              </a>

              <a v-if="facebook" :href="facebook?.uri?.path" :title="$texts('footer.facebook', 'Facebook')"
                target="_blank">
                <i class="fab fa-facebook-f"></i>
              </a>

              <a v-if="youtube" :href="youtube?.uri?.path" :title="$texts('footer.youtube', 'YouTube')" target="_blank">
                <i class="fab fa-youtube"></i>
              </a>
            </div>

          </div>

          <div v-if="tenantId == 'equans'" class="etx-flex__item Flex__item mob-l:c-auto">

            <div class="FooterPartner">

              <div class="FooterPartner__text">

                <div class="etx-text Text a-right">
                  <p class="font-size-small">{{ $texts('footer.partner', 'Partnerin von') }}</p>
                </div>

              </div>

              <div class="FooterPartner__logo">
                <SpriteSymbol name="logo_swissathletics_neg" style="width:87px;height:34px" />
              </div>

            </div>

          </div>

        </div>


        <div class="etx-spacer Spacer h-50 mob-l:h-25"></div>
        <hr>
        <div class="etx-spacer Spacer h-50 mob-l:h-25"></div>


        <div class="etx-flex Flex tab-s:av-center tab-s:a-space-between">

          <div class="etx-flex__item Flex__item tab-s:c-auto tab-s:o-2">

            <div class="FooterNavMeta">

              <ul>
                <li v-for="link in metaMenuLinks" :key="link.link.label">
                  <a v-if="link.link.url" :href="link.link.url.path" :title="link.link.label">{{ link.link.label }}</a>
                </li>
              </ul>

            </div>

          </div>

          <div class="etx-flex__item Flex__item tab-s:c-auto">

            <div class="FooterCopyright">

              <div class="etx-text Text">
                <p class="font-size-small">© {{ companyName }} {{ currentYear }}</p>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>

  </footer>
</template>

<script lang="ts" setup>
const { $texts } = useNuxtApp()
const tenantId = useTenant()
const initData: Ref<InitData> = await useInitData()

const { footerMenuLinks, footerMetaMenuLinks, globalConfig } = initData.value

const { address, companyName, emailAddress, phoneNumber, linkedin, instagram, facebook, youtube } = globalConfig

const addressText = computed(() => address?.replace('<p>', '').replace('</p>', ''))

const firstColumnLink = computed(() => footerMenuLinks[0]?.link);
const firstColumnSubtree = computed(() => footerMenuLinks[0]?.subtree);
// const secondColumnLink = computed(() => footerMenuLinks[1]?.link);
// const secondColumnSubtree = computed(() => footerMenuLinks[1]?.subtree);
const thirdColumnLinks = computed(() => footerMenuLinks.slice(2).map(item => item.link));

const metaMenuLinks = computed(() => footerMetaMenuLinks)

const currentYear = computed(() => new Date().getFullYear().toString())
</script>
